// extracted by mini-css-extract-plugin
module.exports = {"landing":"landin_landing__1NsO-","button":"landin_button__10gqZ"};